<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-show="showModal">
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <form @submit.prevent="$emit('submit')">
                    <header
                        class="modal-header"
                        id="modalTitle"
                    >
                        <h3 class="modal-header__title">{{title}}</h3>
                        <div
                            type="button"
                            class="btn-close"
                            @click="close"
                            aria-label="Close modal"
                        ><div class="close-sign"></div></div>
                    </header>
                    <section
                        :class="bodyClass"
                        id="modalDescription"
                    >
                        <slot name="body">
                            I'm the default body!
                        </slot>
                    </section>
                    <footer class="modal-footer">
                        <slot name="footer">
                        </slot>
                    </footer>
                </form>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'custom-popup',
        methods: {
            close() {
                this.$emit('close');
            },
        },
        props: {
            title: {
                type: String,
                default: "Custom Modal",
            },
            bodyClass: {
                type: String,
                default: "modal-body",
            },
            showModal: {
                type: Boolean|String,
                default: false
            }
        }
    }
</script>
<style scoped lang="scss">
    .modal-fade-enter,
    .modal-fade-leave-active {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(44, 44, 44, 0.13);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999999;
    }

    .modal {
        background: #FFFFFF;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
        width: 690px;
    }

    .modal-header,
    .modal-footer {
        position: relative;
        display: flex;
        justify-content: center;
    }

    .modal-header {
        padding-top: 51px;
        padding-bottom: 55px;
    }

    .modal-footer {
        padding-top: 46px;
        padding-bottom: 57px;
    }

    .modal-header__title {
        font-weight: 700;
        font-size: 24px;
        color: var(--blue-color);
    }

    .modal-body {
        position: relative;
        padding: 0 100px;
    }

    .btn-close {
        position: absolute;
        top: 20px;
        right: 35px;
        cursor: pointer;
    }

    .close-sign:before, .close-sign:after {
        content: ' ';
        position: absolute;
        height: 18px;
        width: 2px;
        background-color: #0C8CFB;
    }
    .close-sign:before {
        transform: rotate(45deg);
    }
    .close-sign:after {
        transform: rotate(-45deg);
    }
</style>
